var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSharedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 8.00016C9.84062 8.00016 11.333 6.50778 11.333 4.66683C11.333 2.82588 9.84062 1.3335 7.99967 1.3335C6.15873 1.3335 4.66634 2.82588 4.66634 4.66683C4.66634 6.50778 6.15873 8.00016 7.99967 8.00016ZM10.2219 4.66683C10.2219 5.89413 9.22697 6.88905 7.99967 6.88905C6.77238 6.88905 5.77745 5.89413 5.77745 4.66683C5.77745 3.43953 6.77238 2.44461 7.99967 2.44461C9.22697 2.44461 10.2219 3.43953 10.2219 4.66683Z",
    fill: "#585858"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6663 13.5557C14.6663 14.6668 13.5552 14.6668 13.5552 14.6668H2.44412C2.44412 14.6668 1.33301 14.6668 1.33301 13.5557C1.33301 12.4446 2.44412 9.11127 7.99967 9.11127C13.5552 9.11127 14.6663 12.4446 14.6663 13.5557ZM13.5552 13.5519C13.5536 13.2776 13.3844 12.4562 12.6307 11.7025C11.9059 10.9778 10.5431 10.2224 7.99966 10.2224C5.45621 10.2224 4.0934 10.9778 3.36867 11.7025C2.61496 12.4562 2.4457 13.2776 2.44412 13.5519H13.5552Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharedIcon);
export default __webpack_public_path__ + "static/media/sharedIcon.eedac609d230a786c067d3d893aceef4.svg";
export { ForwardRef as ReactComponent };